<template>
    <div class="Carousel">
        <div class="carousel-top-container">
            <h3>{{ title }}</h3>
        </div>
        <carousel v-if="itemsType === 'systems'" class="carousel" :per-page="5" :pagination-enabled="false">
            <slide v-for="item in items" :key="item.name" class="slide">
                <systems-carousel-item
                    :system="item"
                    :active-system-id="activeSystemId"
                    @systemClicked="e => $emit('systemClicked', { systemId: e.systemId })"
                />
            </slide>
        </carousel>

        <carousel v-else-if="itemsType === 'games'" class="carousel" :per-page="5" :pagination-enabled="false">
            <slide v-for="item in items" :key="item" class="slide">
                <games-carousel-item :game-id="item" />
            </slide>
        </carousel>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { Carousel, Slide } from 'vue-carousel';

import SystemsCarouselItem from './SystemsCarouselItem.vue';
import GamesCarouselItem from './GamesCarouselItem.vue';

export default {
    components: {
        SystemsCarouselItem,
        GamesCarouselItem,
        Carousel,
        Slide
    },

    props: {
        title: {
            type: String,
            required: true,
            default: ''
        },

        itemsType: {
            type: String,
            required: true,
            default: ''
        },

        items: {
            type: Array,
            required: true,
            default: () => []
        },

        activeSystemId: {
            type: String,
            required: false,
            default: null
        }
    }
};
</script>

<style lang="scss" scoped>
.carousel-top-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0.5em 0;
}
</style>
